import {MutationTree} from "vuex";
import * as moment from 'moment';
import Project from "../ts/ProjectInterface";
import Category from "../ts/CategoryInterface";
import ProjectStatsInterface from "../ts/ProjectStatsInterface";
import ProjectErrorInterface from "../ts/ProjectErrorInterface";

export const mutations: MutationTree<any> = {

    setActiveTab(state: any, payload: boolean) {
        state.activeTabModel = payload;
    },

    setProjectsLoading(state: any, payload: any) {
        state.projectsLoading = payload;
    },

    setProjects(state: any, payload: any) {
        state.projectsCacheExpires = moment().add(5, 'minutes');
        state.projects = payload;
    },

    setActiveTableOptions(state: any, payload: object) {
        state.activeTableOptions = payload;
    },

    setArchivedProjects(state: any, payload: any) {
        state.archivedProjects = payload;
    },

    setArchivedTableOptions(state: any, payload: object) {
        state.archivedTableOptions = payload;
    },

    setArchivedTableSearch(state: any, payload: string) {
        state.archivedTableSearch = payload;
    },

    createProject(state: any, project: Project) {

        state.projects.push(project);
    },

    updateProject(state: any, project: Project) {

        if (project.status !== 'archived') {

            let found = state.projects.find((p: Project) => {
                return p.id === project.id;
            });

            if (found) found = Object.assign(found, project);

        } else {

            let found = state.archivedProjects.find((p: Project) => {
                return p.id === project.id;
            });

            if (found) found = Object.assign(found, project);
        }
    },

    updateProjectStatus(state: any, data: any) {

        let found = state.projects.find((p: Project) => {
            return p.id === data.id;
        });

        // Check if in archived projects
        if (!found) {
            const index = state.archivedProjects.findIndex((p: Project) => {
                return p.id === data.id;
            });

            found = state.archivedProjects[index];

            // Move to projects
            state.projects.push(found);
            state.archivedProjects.splice(index, 1);
        }

        found.status = data.status;
    },

    deleteProject(state: any, id: number) {
        let indexProject = state.projects.findIndex((project: Project) => {
            return project.id == id;
        });

        state.projects.splice(indexProject, 1);

        let indexArchived = state.archivedProjects.findIndex((project: Project) => {
            return project.id == id;
        });

        state.archivedProjects.splice(indexArchived, 1);
    },

    setCategoriesLoading(state: any, payload: any) {
        state.categoriesLoading = payload;
    },

    setCategories(state: any, payload: any) {
        state.categoriesCacheExpires = moment().add(15, 'minutes');
        state.categories = payload;
    },

    setActiveTableSortBy(state: any, payload: any) {
        state.activeTableSortBy = payload;
    },

    setActiveTableSortDesc(state: any, payload: any) {
        state.activeTableSortDesc = payload;
    },

    setActiveTableSearch(state: any, payload: any) {
        state.activeTableSearch = payload;
    },

    createCategory(state: any, payload: Category) {
        state.categories.push(payload);
    },

    updateCategory(state: any, payload: Category) {
        let found = state.categories.find((category: Category) => category.id === payload.id);

        found = Object.assign(found, payload);
    },

    deleteCategory(state: any, category: Category) {
        let index = state.categories.findIndex((cat: Category) => cat.id === category.id);

        state.categories.splice(index, 1);
    },

    saveCategoryId(state: any, id: number) {
        let found = state.categories.find((category: Category) => category.id === -1);

        if (!found) console.error("Category not found with ID 999999");

        found.id = id;
    },

    setProjectStatsLoading(state: any, payload: any) {
        state.projectStatsLoading = payload;
    },

    setProjectStats(state: any, payload: any) {

        let index = state.projectStats.findIndex((stats: ProjectStatsInterface) => {
            return stats.id === payload.id
        });

        // Replace
        if (index !== null) {
            state.projectStats.splice(index, 1, payload);
        } else {
            state.projectStats.push(payload);
        }
    },

    setProjectGeoStatsLoading(state: any, payload: any) {
        state.projectGeoStatsLoading = payload;
    },

    setProjectGeoStats(state: any, payload: any) {

        let index = state.projectGeoStats.findIndex((stats: ProjectStatsInterface) => {
            return stats.id === payload.id
        });

        // Replace
        if (index !== null) {
            state.projectGeoStats.splice(index, 1, payload);
        } else {
            state.projectGeoStats.push(payload);
        }
    },

    setProjectSupplierStatsLoading(state: any, payload: any) {
        state.projectSupplierStatsLoading = payload;
    },

    setProjectSupplierStats(state: any, payload: any) {

        let index = state.projectSupplierStats.findIndex((stats: ProjectStatsInterface) => {
            return stats.id === payload.id
        });

        // Replace
        if (index !== null) {
            state.projectSupplierStats.splice(index, 1, payload);
        } else {
            state.projectSupplierStats.push(payload);
        }
    },

    deleteProjectErrors(state: any, id: number) {

        let project = state.projects.find((project: Project) => {
            return project.id == id;
        });

        project.errors = [];
    },

    deleteProjectError(state: any, projectError: ProjectErrorInterface) {

        let project = state.projects.find((project: Project) => {
            return projectError.project_id === project.id;
        });

        const index = project.errors.findIndex((error: ProjectErrorInterface) => {
            return projectError.id == error.id;
        });

        project.errors.splice(index, 1);
    },
};
